import React from "react";
import styled from "styled-components";
import SocialMedia from "./SocialMedia";
import P from "../../../utils/p/P";
import { Colors } from "../../../utils/colors/colors";





const InitiativesFooter = () => {
  const { whiteColor } = Colors();

  return (
    <Wrapper>
      <P
        textColor={whiteColor}
        text={"Follow us"}
        style={{
          fontSize: "1rem",
          fontWeight: 700,
          minWidth: "100px",
        }}
        isAnimatable={false}
      />

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="370"
        height="2"
        viewBox="0 0 370 2"
        fill="none"
      >
        <path d="M1 1L369 1.00003" stroke="white" stroke-linecap="round" />
      </svg>

      <SocialMedia />
    </Wrapper>
  );
};

export default InitiativesFooter;

const Wrapper = styled.div`
  background-color: var(--primary-color);
  display: flex;
  padding: 0px 20px;
  gap: 20px;
  justify-content: space-between;
  align-items: center;
  position: static;
  bottom: 0;
  min-width: 100%;
`;
